
	import {
		Component,
		Vue,
		Inject,
		Prop,
		Watch,
	} from 'vue-property-decorator';
	import Util from '@/lib/util';
	import wx from 'weixin-js-sdk';
	import AbpBase from '@/lib/abpbase';
	import Viewer from 'v-viewer'
	import videojs from 'video.js';
	import 'viewerjs/dist/viewer.css'
	@Component({
		components: {}
	})
	export default class NewsDetail extends AbpBase {
		userAgent: string = "";
		news: Object = new Object() as any;
		newid: number = 0;
		pageSize: number = 10;
		pageIndex: number = 1;
		userid: number = 0;
		commentBox: boolean = false;
		commentList: Array < Object >= new Array < Object > ();
		commentContent: string = "";
		loadmore: boolean = true;

		userInfo: Object = new Object();
		anonymous: boolean = false;
		imgBox: boolean = false;
		currentImgs: Array < Object >= new Array < Object > ();
		currentImgUrl: string = '';


		showShare: boolean = false;
		shownews: number = 0; // 0加载中 1 可见 2 不可见
		msg: string = '';
		isPreview: boolean = false;
		newsReadCount: number = 0;
		screenWidth:number=0;

		hideCommentBox() {
			this.commentContent = "";
			this.commentBox = false;
		}
		goFullText() {
			location.href = ((this.news as any).fullTextUrl);
		}

		showCommentBox() {
			this.commentContent = "";
			this.commentBox = true;
		}
		share() {
			this.showShare = true;

		}
		isIos() {
			var u = navigator.userAgent.toLowerCase();
			this.userAgent = u;
			if (u.indexOf("iphone") > -1 || u.indexOf("ios") > -1 || u.indexOf("mac") > -1) {
				return true;
			}
			return false;
		}

		getNewsByID() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getXueXiById',
				id: this.newid
			}).then((res) => {
				console.log(res);
				that.news = res as any;

				var date = (that.news as any).publishTime;
				if (date == null) {
					date = (that.news as any).creationTime;
				}
				(that.news as any).time = Util.formatDate(new Date(date), 'yyyy-MM-dd hh:mm:ss');

			})
		}
		// writeNewsReadLog() {
		// 	var that = this;
		// 	this.$store.dispatch({
		// 		type: 'app/writeNewsReadLog',
		// 		data: {
		// 			id: that.newid
		// 		}
		// 	}).then((res) => {

		// 	})
		// }

		getLoginUser() {
			var that = this;
			this.$store.dispatch({
				type: 'app/getLoginUser',
				data: {}
			}).then(res => {
				that.userInfo = res;
			})
		}
		cancelImgBox() {
			this.imgBox = false;
		}

		@Watch('$route')
		routechange(to: any, from: any) {
			if (to.query.newid != from.query.newid) {
				location.reload();
			}
		}
		async created() {
			var that=this;
			that.screenWidth = document.body.clientWidth
			console.log(that.screenWidth)
			if (!Util.abp.session.userId) {
				var domain = this.$route.query.domain as any;
				if (domain != undefined && domain != null && domain != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSDOMAIN",
							"ProviderAccessCode": domain,
							ProviderKey: "",
							Property: ""
						},
					})
					location.reload();
				}
				var userId = this.$route.query.userid as any;
				if (userId != undefined && userId != null && userId != '') {
					await this.$store.dispatch({
						type: 'app/externalAuthenticate',
						data: {
							"AuthProvider": "IDSID",
							"ProviderAccessCode": userId,
							ProviderKey: userId,
							Property: ""
						},
					})
					location.reload();
				}
			}
			if (this.$route.query.newid && (this.$route.query.newid as any) > 0) {
				this.newid = this.$route.query.newid as any;
				console.log(Util.abp.session.userId);
				if (Util.abp.session.userId) {
					this.userid = Util.abp.session.userId;
					this.getLoginUser();

				}
				if (this.$route.query.preview && (this.$route.query.preview as any) > 0) {
					this.isPreview = true;
				}
				this.getNewsByID();
			}


		}
		mounted() {
			var that = this;
			setTimeout(function() {

				var u = navigator.userAgent.toLowerCase();
				console.log("u:" + u);
				//统一使用组件方式查看图片可以缩放
				if (1==1 ||u.indexOf('iphone os 13_4') > -1 || u.indexOf('iphone os 14') > -1 || u.indexOf('ipad') > -1 ||
					u.indexOf('ipod') > -1 || that.screenWidth>=768) {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');
					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							// that.currentImgUrl = e.currentTarget.src;
							// that.currentImgs = [];
							// that.currentImgs.push(that.currentImgUrl);
							// that.imgBox = true;
							// that.$forceUpdate();
							//(window as any).gis.previewImage([e.currentTarget.src]);
							that.currentImgUrl = e.currentTarget.src;
							that.currentImgs = [];
							that.currentImgs.push(that.currentImgUrl);
							//that.imgBox = true;
							const ViewerDom = document.getElementById('viewer');
							((ViewerDom as any).viewer as any).options.title = false;
							((ViewerDom as any).viewer as any).options.navbar = false;
							((ViewerDom as any).viewer as any).options.toolbar = false;
							((ViewerDom as any).viewer as any).images = that.currentImgs;
							setTimeout(function() {
								var contain = document.getElementsByClassName('descimgBox')[0]
									.getElementsByTagName('img');;
								if (contain != null && contain.length > 0) {
									contain[0].click();
								}
							}, 300)
						}
						// img.ontouchend = function(e) {
						// 	(window as any).gis.previewImage([e.currentTarget.src]);
						// }
					}
				} else {
					let imgs = document.getElementsByClassName('newscot')[0].getElementsByTagName('img');

					for (var i = 0; i < imgs.length; i++) {
						var img = imgs[i] as any;
						img.onclick = function(e) {
							var img = imgs[i] as any;
							img.onclick = function(e) {
								(window as any).gis.previewImage([e.currentTarget.src]);
							}
						}

					}
				}


				let mps = document.getElementsByTagName('mp-miniprogram');
				for (var i = 0; i < mps.length; i++) {
					var mp = mps[i] as any;
					var miniprogramAppid = mp.dataset.miniprogramAppid;
					var imageUrl = mp.dataset.miniprogramImageurl
					var miniprogramPath = mp.dataset.miniprogramPath;
					var miniprogramTitle = mp.dataset.miniprogramTitle;
					var miniprogramType = mp.dataset.miniprogramType;
					var dom =
						'<span class="weapp_display_element js_weapp_display_element">' +
						'<span class="weapp_card app_context pages_reset appmsg_card_context appmsg_card_active">' +
						'<span class="weapp_card_bd" style="border: 1px solid #ddd;border-radius: 3px;padding: 10px;display: block;">' +
						'<span class="weapp_card_profile flex_context" style="display:block;text-align: left;">' +
						'<span class="radius_avatar weapp_card_avatar" style="display: inline-block;width: 30px;height:30px;border-radious:50%;vertical-align: middle;overflow: hidden;margin-right:10px;">' +
						'<img  src="' + imageUrl + '" style="display:block;width:100%;height:100%;">' +
						'</span>' +
						'<span class="flex_bd">' +
						'<span class="weapp_card_nickname_wrp">' +
						'<span class="guarantee_icon">交易担保</span>' +
						'<span class="weapp_card_nickname">小延商城</span>' +
						'</span>' +
						'</span>' +
						'</span>' +
						'<span class="weapp_card_info" style="display:block;">' +
						'<span class="weapp_card_title" style="display:block;text-align: left;font-size:15px;color:#333;margin:5px 0;">' +
						miniprogramTitle + '</span>' +
						'<span class="weapp_card_thumb_wrp" style="display:block;width:100%;"></span>' +
						'<img mode="widthFix" src="' + imageUrl + '" style="display:block;width:100%;">' +
						'</span>' +
						'</span>' +
						'<span class="weapp_card_ft">' +
						'<span class="weapp_card_logo" style="margin:10px 0;color:#666;">小程序</span>' +
						'</span>' +
						'</span>' +
						'</span>';
					var node = document.createElement("div");
					node.innerHTML = dom;
					mp.parentNode.appendChild(node);
				}
			}, 2000)
		}
	};
